import React from 'react';
import styles from './SelectedOption.module.scss';
import Times from '../../Icons/Times';
import { type IOption } from '../../shared/models/IOption';

export interface ISelectedOption {
  option: IOption;
  onUnselect: () => void;
}

export default function SelectedOption({ option, onUnselect }: ISelectedOption) {
  return (
    <div className={styles.selectedItem}>
      <span>{option.text}</span>
      <button
        id={`unselect-${option.value}`}
        onClick={onUnselect}
        aria-label={`Click to unselect ${option.text}`}
      >
        <Times />
      </button>
    </div>
  );
}
